import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Construction, MessageCircle } from 'lucide-react';
import { hotelInfo } from "../mockData";

const UnderConstruction = () => {
    const whatsappNumber = hotelInfo.whatsapp.replace("+", "");
    const message = encodeURIComponent(
        `Hello, I would like to inquire about ${hotelInfo.name}.`
    );
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cyan-50 to-white px-4">
            <Card className="max-w-xl w-full text-center shadow-2xl border-none">
                <CardContent className="p-10">
                    <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-cyan-400 to-cyan-500 rounded-full flex items-center justify-center">
                        <Construction className="w-10 h-10 text-white" />
                    </div>

                    <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        We’re Under Construction
                    </h1>

                    <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                        Lilly Of The Valley Inn is preparing a calm and elegant online
                        experience to match the comfort of your stay with us.
                    </p>

                    <p className="text-gray-500 mb-8">
                        Our full website will be available very soon.
                    </p>

                    <a
                        href={`https://wa.me/${whatsappNumber}?text=${message}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white text-lg font-semibold px-8 py-4 rounded-xl shadow-lg transition-all duration-300 hover:scale-105"
                    >
                        <MessageCircle className="w-6 h-6" />
                        Reach Us on WhatsApp
                    </a>

                    <p className="mt-8 text-sm text-gray-400">
                        © Lilly Of The Valley Inn · Kandy · Sri Lanka
                    </p>
                </CardContent>
            </Card>
        </div>
    );
};

export default UnderConstruction;
